import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { Subject, combineLatest } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Location } from '@angular/common';
import { SelectItem, MessageService } from 'primeng/api';
import { Store } from '@ngrx/store';
import * as fromStore from '../../../store';
import { PreferenceService } from '../../../services/preference.service';
import { CryptoService } from '../../../services/crypto.service';
import { PaymentDocumentPdfComponent } from '../document-pdf/document-pdf.component';
import { Router, ActivatedRoute } from '@angular/router';
import * as fromFeature from '../../../my-features';
import { mspPaymentDocumentStatusNumber, updateInfoType, DocumentTypeName, PaymentTypeIndex } from '../../../shareModel';
import {UpdateInfoModel} from '../../../my-features/updateInfo/update-info.model';
import { CellEditor } from 'primeng/table';
import { RegionService } from '../../../services/region.service';

interface Document {
  DocNo: string;
  MonthYear: string;
  UsedDevice: number;
  UnitPrice: number;
  TotalPrice: number;
  GenerateTime: string;
  CloseTime: string;
  Status: string;
  CorrNo: string;
  Create: string;
}

@Component({
  standalone: false,
  selector: 'app-document-info',
  templateUrl: './document-info.component.html',
  styleUrls: ['./document-info.component.css']
})
export class PaymentDocumentInfoComponent implements OnInit, OnDestroy {
  @ViewChild(CellEditor, { static: false }) cellEditor: CellEditor;
  @ViewChild(PaymentDocumentPdfComponent, { static: false }) childDialog: PaymentDocumentPdfComponent;
  private componentDestroyed = new Subject();
  UpdateInfoParam = {} as UpdateInfoModel;
  docTable_cols: any[] = [
    { field: 'No.', header: 'No.', width: '70', class: 'col-nowrap' },
    { field: 'DocNo', header: 'Invoice/PO No.', width: '150', class: 'col-nowrap' },
    { field: 'Download', header: '', width: '55', class: 'col-nowrap' },
    { field: 'PaymentType', header: 'Purchase Type', width: '150', class: 'col-nowrap' },
    { field: 'MonthYear', header: 'Month/Year', width: '150', class: 'col-nowrap' },
    { field: 'PaymentUsage', header: 'Quantity (NPM)', width: '150', class: 'col-nowrap' },
    { field: 'UnitPrice', header: 'Unit Price (USD)', width: '150', class: 'col-nowrap' },
    { field: 'PaymentPrice', header: 'Total Price (USD)', width: '150', class: 'col-nowrap' },
    { field: 'GenerateTime', header: 'Generate Time', width: '180', class: 'col-nowrap' },
    { field: 'CreateBy', header: 'Created by', width: '220', class: 'col-nowrap' },
    { field: 'CloseTime', header: 'Close Time', width: '180', class: 'col-nowrap' },
    { field: 'CorrNo', header: 'Invoice No.', width: '200', class: 'col-nowrap' },
    { field: 'IsFree', header: 'Test/Free', width: '120', class: 'col-nowrap' }
  ];
  docList: Document[];
  statusOptions: SelectItem[] = [
    { label: 'Open', value: 'Open' },
    { label: 'Close', value: 'Close' },
  ];

  dialogVisibility = {
    confirm: false,
    DocPDF: false,
    confirmPayment: false,
    confirmDelete: false,
  };

  dialogInput = {
    DocNo: '',
    previousStatus: '',
    newStatus: '',
  };

  clonedDoc: { [s: string]: Document; } = {};
  rowDataStatus = {};
  rowDataStatusPrevious = {};
  rowIndex: number;
  isSystemAdmin = false;
  isAdmin = false;
  isMsp = false;
  regionId: number;
  getMspDocParam = {
    otp: '',
    RegionId: 0
  };
  getProNodesBankParam = {
    otp: '',
    RegionIds: []
  };
  getPaymentSettingParam = {
    otp: '',
    RegionId: []
  };
  getMspDeviceUsageParam = {
    otp: '',
    RegionId: 0,
    IsDistributorAll: false
  };
  getPaymentByDistributorParam = {
    RegionId: 0,
    otp: ''
  };
  doc_Title: '';
  isMspLoaded = false;
  originalValues: any[];
  isChanging: boolean = false;
  selectedNode = null;
  frozenCols: any[];
  accountActivityList = [];
  accountActivityTable_cols: any[] = [
    { field: 'CreateTime', header: 'Time', width: '180', class: 'col-nowrap' },
    { field: 'RegionName', header: 'Company', width: '220', class: 'col-nowrap' },
    { field: 'ActionTypeStr', header: 'Type', width: '180', class: 'col-nowrap' },
    { field: 'Nodes', header: 'Quantity (NPM)', width: '180', class: 'col-nowrap' },
    { field: 'Balance', header: 'NPM Bank', width: '180', class: 'col-nowrap' },
  ];
  PROPaymentSetting = {
    CurrentNPMBank: 0,
    DocDay: 0,
    Email: []
  };
  predictedNPMUsageList = [];
  predictedNPMUsage = {
    LastDeviceUsage: 0,
    Growth: 0,
    PredictedDeviceUsage: 0,
    SettlementDate: '2025/02/01',
    PredictedBank: 0,
  }
  predictedNPMUsageTable_cols: any[] = [
    { field: 'LastDeviceUsage', header: 'NPM Usage Last Month', width: '180', class: 'col-nowrap' },
    { field: 'Growth', header: 'NPM Usage growth this month', width: '250', class: 'col-nowrap' },
    { field: 'PredictedDeviceUsage', header: 'Predicted NPM Usage This Month', width: '300', class: 'col-nowrap' },
    { field: 'SettlementDate', header: 'Next Settlement Date', width: '200', class: 'col-nowrap' },
    { field: 'PredictedBank', header: 'Predicted NPM Bank This Month', width: '250', class: 'col-nowrap' },
  ];
  mspPaymentDocumentStatusNumber = mspPaymentDocumentStatusNumber;
  latestNodeBankBalance: number = 0;
  PaymentTypeIndex = PaymentTypeIndex;
  payment_regionId_dic = [];
  dis_region_payment_dic = [];
  deviceUsage_list_dic = [];
  constructor(private ngxService: NgxUiLoaderService, private store: Store<fromStore.State>, public preferenceService: PreferenceService,
    private cryptoService: CryptoService, private _location: Location, private router: Router, private route: ActivatedRoute,
    private messageService: MessageService, private regionService: RegionService) {
    this.docList = [];
    this.regionId = parseInt(this.cryptoService.aesDecrypt(this.route.snapshot.paramMap.get('id')));
    this.getMspDocParam = {
      ...this.getMspDocParam,
      RegionId: this.regionId,
    };
    this.getProNodesBankParam = {
      ...this.getProNodesBankParam,
      RegionIds: [this.regionId],
    };
    if (this.getMspDocParam !== undefined) {
      this.store.dispatch(new fromFeature.ReadMspPaymentDocumentList({ ...this.getMspDocParam }));
      this.store.dispatch(new fromFeature.GetProNodesBank({ ...this.getProNodesBankParam }));
      
    }

    // Msp Data
    combineLatest(this.store.select(fromStore.getIsMsp), this.store.select(fromStore.getCurrentUser))
    .pipe(takeUntil(this.componentDestroyed))
    .subscribe(([getIsMspRes, getCurrentUserRes]) => {
      if ((getIsMspRes !== undefined && getIsMspRes !== null) && (getCurrentUserRes !== undefined && getCurrentUserRes !== null)) {
        // Get IsMsp
        this.isMspLoaded = true;
        if (getIsMspRes && getCurrentUserRes.authority === 1) {
          this.router.navigate(['/dashboard']);
        }
      }
      if ((getIsMspRes !== undefined && getIsMspRes !== null) &&
      (getCurrentUserRes !== undefined && getCurrentUserRes !== null)) {
        this.isSystemAdmin = getCurrentUserRes.authority === 2;
        this.isAdmin = getCurrentUserRes.authority === 1;
        this.isMsp = getIsMspRes;
        if (!this.isSystemAdmin && this.isAdmin && !this.isMsp) {
          this.getPaymentSettingParam = {
            ...this.getPaymentSettingParam,
            RegionId: [getCurrentUserRes.RegionId],
          };
        }
        this.isMspLoaded = true;
        // if (this.isAdmin) {
        //   this.getMspDeviceUsageParam.RegionId = this.regionId
        // }
        this.getMspDeviceUsageParam = {
          ...this.getMspDeviceUsageParam,
          RegionId: this.regionId,
          IsDistributorAll: true,
        };
        this.store.dispatch(new fromFeature.GetMspRegionPayment({ ...this.getPaymentSettingParam }));
        this.store.dispatch(new fromFeature.ReadMspDeviceUsageList({ ...this.getMspDeviceUsageParam }));
        this.getPaymentByDistributorParam = {
          RegionId: this.regionId,
          otp: ''
        };
        this.store.dispatch(new fromFeature.GetMspPaymentSettingByDistributor({ ...this.getPaymentByDistributorParam }));
        this.ngxService.stop();
      }
    });
    
    this.store.select(fromStore.getMspRegionPayment).pipe(takeUntil(this.componentDestroyed)).subscribe((res) => {
      if ((res !== undefined && res !== null)) {
        const payment_info = res.payment_dic[this.regionId][0];
        if (payment_info !== undefined && payment_info.EmailInfo !== undefined && Array.isArray(payment_info.EmailInfo)) {
          this.PROPaymentSetting.Email = payment_info.EmailInfo;
        } else {
          this.PROPaymentSetting.Email = [];
        }
        let payment_setting: any = null;
        payment_setting = res.payment_list.find(info => info && info.MspRegionId === this.regionId);
        if (!payment_setting) {
          const parent = res.payment_list.find(info => 
            info && info.Customers && info.Customers.find(c => c.MspRegionId === this.regionId)
          );
          if (parent) {
            payment_setting = parent.Customers.find(c => c.MspRegionId === this.regionId);
          }
        }
        if (payment_setting !== undefined && payment_setting !== null) {     
          
          this.PROPaymentSetting.CurrentNPMBank = payment_setting.Nodes;
          this.PROPaymentSetting.DocDay = payment_setting.DocDay;
          this.getPredictedNPMUsage();
          this.getPredictedNPMUsageData();
        }
      }
    });
    
    // Get Distributor RegionPayment
    this.store.select(fromStore.getMspDistributorRegionPayment).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
      if (res !== undefined && res.Customers !== undefined && Array.isArray(res.Customers)) {
        if (res.Customers != undefined && res.Customers.length > 0) {
          res.Customers.map(c => {
            if (c.PaymentRegionId == this.regionId) {
              if (this.payment_regionId_dic[c.PaymentRegionId] === undefined) { // 扣Distributor的Customers
                this.payment_regionId_dic[c.PaymentRegionId] = []
                if (c.PROStatus !== 0) {
                  this.payment_regionId_dic[c.PaymentRegionId].push(c)
                }
              }
            }
          })
        }
      }
    })
    

    // Get Document List
    this.store.select(fromStore.getMspPaymentDocumentList).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
      if (res !== undefined) {
        this.ngxService.start();
        this.doc_Title = res.region_dic[this.regionId] !== undefined ? res.region_dic[this.regionId].RegionName : '';
        this.docList = [...res.doc_List].sort(function (a: any, b: any) {

          if (a.DocId > b.DocId) { return -1; }
          if (a.DocId < b.DocId) { return 1; }
          if (a.DocId === b.DocId) {
            if (new Date(a.DocDate).getTime() > new Date(b.DocDate).getTime()) { return -1; }
            if (new Date(a.DocDate).getTime() < new Date(b.DocDate).getTime()) { return 1; }
          }
          return 0;
        }).map(item => {
          const cryptoDocId = this.cryptoService.aesEncrypt(item.DocId);
          const docType_Name = DocumentTypeName[item.DocType];
          return {
              ...item,
              CryptoDocId: cryptoDocId,
              DocType_Name: docType_Name,
              // IsFree: item.DocType === 1 ? true : false,
              // IsConfirmed: item.DocType === 1 ? true : false,
              // PurchaseType: item.DocType,
          };
        });
        this.originalValues = this.docList.map(row => ({ ...row }));
        this.ngxService.stop();
      }
    });

    this.store.select(fromStore.getUpdateInfoState).pipe(takeUntil(this.componentDestroyed)).subscribe((res) => {
      if (res.type === updateInfoType.UpdateMspPaymentDocument) {
        if (!res.isLoading && res.isLoaded && res.isSaved) {
          this.messageService.add({ severity: 'success', summary: 'Update Success' });
          this.store.dispatch(new fromFeature.ReadMspPaymentDocumentList({ ...this.getMspDocParam }));
          this.store.dispatch(new fromFeature.GetMspRegionPayment({ ...this.getPaymentSettingParam }));
          this.store.dispatch(new fromFeature.GetProNodesBank({ ...this.getProNodesBankParam }));
        } else if (!res.isLoading && res.isLoaded && !res.isSaved) {
          this.messageService.add({ severity: 'error', summary: 'Update Fail' });
        }
        this.resetUpdateInfoState();
        this.ngxService.stop();
      }
      if (res.type === updateInfoType.SendProPaymentDocumentMail) {
        if (!res.isLoading && res.isLoaded && res.isSaved) {
          this.messageService.add({ severity: 'success', summary: 'Send Mail Success' });
        } else if (!res.isLoading && res.isLoaded && !res.isSaved) {
          this.messageService.add({ severity: 'error', summary: 'Send Mail Fail' });
        }
        this.resetUpdateInfoState();
        this.ngxService.stop();
      }
    });

    this.store.select(fromStore.getMspDeviceUsageList(this.regionId)).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
      if (res !== undefined && res.deviceUsage !== undefined && Object.keys(res.deviceUsage).length !== 0 && res.region_dic.length > 0) {
        res.deviceUsage.map((m) => {
          this.deviceUsage_list_dic = [];
          if (Object.keys(res.deviceUsage).length !== 0) {
            res.deviceUsage.map((m) => {
              if (m.data !== undefined && m.data.regionid !== undefined) {
                this.deviceUsage_list_dic[m.data.regionid] = m;
              } else {
                if (m.type === 0) {
                  this.predictedNPMUsage.PredictedDeviceUsage = m.quantity;
                  this.predictedNPMUsage.LastDeviceUsage = m.last_quantity;
                  this.predictedNPMUsage.Growth = m.quantity - m.last_quantity;
                  this.getPredictedNPMUsage();
                }
              }
            });
          }
        });
      }
    });
    
    this.store.select(fromStore.GetProNodesBank).pipe(takeUntil(this.componentDestroyed)).subscribe((res) => {
      if (res.isLoaded && !res.isLoading) {
        this.accountActivityList = Array.isArray(res.entities) ? res.entities.map((e) => ({ ...e })) : [];
        this.latestNodeBankBalance = (this.getProNodesBankParam.RegionIds.length > 0 && res.latestRegionNodeBankDic[this.getProNodesBankParam.RegionIds[0]]) ? res.latestRegionNodeBankDic[this.getProNodesBankParam.RegionIds[0]].Balance : 0;

        this.getPredictedNPMUsageData();
        this.getPredictedNPMUsage();
      }
    });

    this.frozenCols = [
      { field: 'Status', header: 'Status', width: '150', class: 'frozen' },
      { field: 'Send', header: '', width: '60', class: 'send' }
    ];

  }

  ngOnInit() {
  }

  downloadRowDataDoc(rowData) {
    this.childDialog.generatePDF(rowData);
  }

  statusOnChange($event, rowData) {
    this.dialogInput = {
      DocNo: rowData.DocNo,
      previousStatus: this.rowDataStatusPrevious['Status'],
      newStatus: $event.value
    };
    this.dialogVisibility.confirm = true;
    this.rowDataStatus = rowData;
  }

  statusInit(Doc: Document, index) {
    this.clonedDoc[Doc.DocNo] = {...Doc};
    this.rowDataStatusPrevious = this.clonedDoc[Doc.DocNo];
    this.rowIndex = index;
  }

  statusOnSave(Doc) {
    this.clonedDoc[Doc.DocNo] = {...Doc};
    this.docList[this.rowIndex] = this.clonedDoc[Doc.DocNo];
    delete this.clonedDoc[Doc.DocNo];
    this.dialogVisibility.confirm = false;
    const param = {
      otp: '',
      DocId : Doc.DocId,
      DocStatus: mspPaymentDocumentStatusNumber[Doc.Status],
      CorrNo: Doc.CorrNo,
      DocNo: Doc.DocNo,
      // DocDate: Doc.GenerateTime,
      UnitPrice: Doc.UnitPrice,
      PaymentUsage: Doc.PaymentUsage,
      IsFree: Doc.IsFree
    };
    this.store.dispatch(new fromFeature.UpdateMspPaymentDocument(param));
  }

  statusOnCancel(Doc) {
    this.docList[this.rowIndex] = this.clonedDoc[Doc.DocNo];
    delete this.clonedDoc[Doc.DocNo];
  }

  onEditInit($event) {
    if ($event.field === 'CorrNo') {
      const Doc = $event.data;
      this.clonedDoc[Doc.DocNo] = {...Doc};
      this.rowDataStatusPrevious = this.clonedDoc[Doc.DocNo];
      const index = this.docList.findIndex(item => item.DocNo === Doc.DocNo);
      this.rowIndex = index;
    }
  }

  correspodingOnChange(rowData: any, index: number) {
    const originalValue = this.originalValues[index].CorrNo;
    const currentValue = rowData.CorrNo;
    if (currentValue !== originalValue) {
      this.rowDataStatus = rowData;
      this.originalValues[index].CorrNo = currentValue;
      this.isChanging  = true;
    }
  }

  onBlur(rowData: any, index: number) {
    this.cellEditor.editableColumn.closeEditingCell(true, null);
    if (this.isChanging) {
      this.isChanging = false;
      this.saveDocument(rowData);
    }
  }

  saveDocument(Doc: any) {
    const param = {
      otp: '',
      DocId : Doc.DocId,
      DocStatus: mspPaymentDocumentStatusNumber[Doc.Status],
      CorrNo: Doc.CorrNo,
      DocNo: Doc.DocNo,
      // DocDate: Doc.GenerateTime,
      UnitPrice: Doc.UnitPrice,
      PaymentUsage: Doc.PaymentUsage,
      IsFree: Doc.IsFree
    };
    this.store.dispatch(new fromFeature.UpdateMspPaymentDocument(param));
  }

  backClicked() {
    this._location.back();
  }

  showGeneratePaymentDocument(type) {
    if (type === 'add') {
      this.router.navigate(['management/payment/generate-document-manually/' + this.route.snapshot.paramMap.get('id')]);
      this.regionService.RemoveBillingStatement();
    } else {
      this.router.navigate(['management/payment/generate-document-manually/' + this.route.snapshot.paramMap.get('id')]);
      const queryParams = {
        'DocId' : this.selectedNode.DocId,
        'DocNo': this.selectedNode.DocNo,
        'PaymentType': this.selectedNode.PaymentType,
        'DocStatus': this.selectedNode.DocStatus,
        'PaymentUsage': this.selectedNode.PaymentUsage,
        'UnitPrice':this.selectedNode.UnitPrice,
        'Month': this.selectedNode.Month,
        'Year': this.selectedNode.Year,
        'IsFree': this.selectedNode.IsFree
      };
      this.regionService.SetBillingStatement = queryParams;
    }
  }

  showConfirmPayment() {
    this.dialogVisibility.confirmPayment = true;
  }

  confirmPayment() {
    if (this.selectedNode) {
      this.ngxService.start();
      const param = {
        otp: '',
        DocId : this.selectedNode.DocId,
        DocStatus: mspPaymentDocumentStatusNumber.Open,
      };
      this.store.dispatch(new fromFeature.UpdateMspPaymentDocument(param));
      this.dialogVisibility.confirmPayment = false;
      this.selectedNode = null;
    }
  }

  showConfirmDeleteDialog() {
    this.dialogVisibility.confirmDelete = true;
  }

  deletePayment() {
    if (this.selectedNode) {
      
      this.ngxService.start();
      const param = {
        otp: '',
        DocId : this.selectedNode.DocId,
        DocStatus: mspPaymentDocumentStatusNumber.Cancel
      };
      this.store.dispatch(new fromFeature.UpdateMspPaymentDocument(param));
      this.dialogVisibility.confirmDelete = false;
    }
  }

  getPredictedNPMUsage() {
    let current_npm = 0;
    if (this.PROPaymentSetting.CurrentNPMBank !== undefined) {
      current_npm = this.PROPaymentSetting.CurrentNPMBank
    }
    let device_usage = 0;
    // let last_device_usage = this.predictedNPMUsage.LastDeviceUsage
    // let last_month_flag = false
    let lastmonth_npm_usage = 0
    if (this.accountActivityList.length > 0) {
      // last_month_flag = true
      const now = new Date();
      const last_month = new Date();
      last_month.setMonth(now.getMonth() - 1);
      const last_month_ts = Math.floor(last_month.getTime() / 1000);
      this.accountActivityList.filter(s => s.RegionId == this.regionId && s.ActionType == 1 && s.CreateTime > last_month_ts).map(a => {
        if (a.Nodes !== undefined) {
          lastmonth_npm_usage = lastmonth_npm_usage + a.Nodes
        }
      })
    } else {
      lastmonth_npm_usage = this.predictedNPMUsage.LastDeviceUsage
    }
    if (this.payment_regionId_dic[this.regionId] !== undefined && this.payment_regionId_dic[this.regionId].length > 0) {
      if (this.deviceUsage_list_dic[this.regionId] !== undefined) {
        device_usage = device_usage + this.deviceUsage_list_dic[this.regionId].data.total_quantity;
      }
      this.predictedNPMUsage.PredictedDeviceUsage = 0;
      this.payment_regionId_dic[this.regionId].map(p =>{
        if (p !== undefined) {
          if (this.deviceUsage_list_dic[p.Id] !== undefined) {
            if (p.PaymentRegionId == this.regionId) {
              device_usage = device_usage + this.deviceUsage_list_dic[p.Id].data.total_quantity;
              // if (!last_month_flag) {
              //   lastmonth_npm_usage = lastmonth_npm_usage + this.deviceUsage_list_dic[p.MspRegionId].data.total_last_quantity;
              // }
            }
          }
        }
      })
    } else {
      device_usage = this.predictedNPMUsage.PredictedDeviceUsage
    }
    if (this.PROPaymentSetting.CurrentNPMBank === undefined) {
      this.PROPaymentSetting.CurrentNPMBank = 0
    }
    this.predictedNPMUsage.Growth = device_usage - lastmonth_npm_usage;
    this.predictedNPMUsage.PredictedDeviceUsage = device_usage;
    this.predictedNPMUsage.LastDeviceUsage = lastmonth_npm_usage
    this.predictedNPMUsage.PredictedBank = this.PROPaymentSetting.CurrentNPMBank - this.predictedNPMUsage.PredictedDeviceUsage;
    this.predictedNPMUsageList = [this.predictedNPMUsage];
  }

  getPredictedNPMUsageData() {
    const today = new Date();

    let baseDateForCycle = new Date(today);
    if (today.getDate() < this.PROPaymentSetting.DocDay) {
      baseDateForCycle.setMonth(baseDateForCycle.getMonth() - 1);
    }
    
    const startYear = baseDateForCycle.getFullYear();
    const startMonth = baseDateForCycle.getMonth();
    
    const daysInStartMonth = new Date(startYear, startMonth + 1, 0).getDate();
    const startDay = Math.min(this.PROPaymentSetting.DocDay, daysInStartMonth);
    const startDate = new Date(startYear, startMonth, startDay);

    let nextCycleYear = startYear;
    let nextCycleMonth = startMonth + 1;

    if (nextCycleMonth > 11) {
      nextCycleMonth = 0;
      nextCycleYear += 1;
    }

    const daysInNextCycleMonth = new Date(nextCycleYear, nextCycleMonth + 1, 0).getDate();
    const nextCycleStartDay = Math.min(this.PROPaymentSetting.DocDay, daysInNextCycleMonth);
    const nextCycleStartDate = new Date(nextCycleYear, nextCycleMonth, nextCycleStartDay);
    
    const endDate = new Date(nextCycleStartDate);
    endDate.setDate(endDate.getDate() - 1);
    startDate.setHours(0, 0, 0, 0);
    endDate.setHours(23, 59, 59, 999);

    const formatDate = (date) => `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;
    // console.log(`DocDay: ${this.PROPaymentSetting.DocDay}, 今天: ${formatDate(today)}`);
    // console.log(`Range: ${formatDate(startDate)} - ${formatDate(endDate)}`);

    this.predictedNPMUsage.SettlementDate = `${formatDate(nextCycleStartDate)}`;
  }

  SendProPaymentDocumentMail(DocId) {
    const param = {
      DocId: DocId
    };
    this.store.dispatch(new fromFeature.SendProPaymentDocumentMail(param));
    this.ngxService.start();
  }


  private resetUpdateInfoState(type: string = updateInfoType.FreeState): void {
    this.UpdateInfoParam = { ...this.UpdateInfoParam, type };
    this.store.dispatch(new fromFeature.UpdateInfoSuccessAction({ ...this.UpdateInfoParam }));
  }

  ngOnDestroy(): void {
    this.componentDestroyed.next(undefined);
    this.componentDestroyed.unsubscribe();
  }
}
